import { contractModule } from "../../reduxV2/contract";
import { EContractFetchType } from "../../reduxV2/contract/contract.types";
import { EContractMemberTypes } from "../../types/contract.types";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { CONTRACT_SELECT_NONE } from "./schema.createTask.types";
var getFilter = function (propertyId) {
    return contractModule.utils.getFilterForProperty(propertyId, EContractFetchType.Active);
};
export var customContractsSelector = function (params) {
    var propertyId = params.propertyId, state = params.state;
    var filter = getFilter(propertyId);
    var contracts = contractModule.selectors.getAllWhere(state, { filter: filter });
    if (!(contracts === null || contracts === void 0 ? void 0 : contracts.items))
        return [];
    var activeContracts = contracts.items.map(function (contract) {
        var startDate = contract.startDate, stopDate = contract.stopDate;
        var dateRange = stopDate
            ? "".concat(formatDate(startDate), " - ").concat(formatDate(stopDate))
            : formatDate(startDate);
        var tenants = contract.members
            .filter(function (member) {
            return member.roles.includes(EContractMemberTypes.Tenant) ||
                member.roles.includes(EContractMemberTypes.Parent);
        })
            .map(function (member) { return "".concat(member.account.firstname, " ").concat(member.account.lastname); })
            .join(", ");
        return {
            id: contract.id,
            value: tenants || getLocalizedText("system.contract"),
            subValue: dateRange,
        };
    });
    if (!(activeContracts === null || activeContracts === void 0 ? void 0 : activeContracts.length)) {
        return [];
    }
    activeContracts.push({
        id: CONTRACT_SELECT_NONE,
        value: getLocalizedText("tasks.create.contract.heading.unspecified"),
        subValue: getLocalizedText("tasks.create.contract.heading.unspecified_message"),
    });
    return activeContracts;
};
export var customIsFetchingSelector = function (params) {
    var state = params.state, propertyId = params.propertyId;
    var filter = getFilter(propertyId);
    return contractModule.selectors.isFetchingAllWhere(state, { filter: filter });
};
export var customGetContractsActions = function (propertyFieldKey) { return [
    function (formData) {
        var filter = getFilter(formData[propertyFieldKey]);
        return contractModule.actions.getAllWhereStart.getAction({
            query: { filter: filter },
        });
    },
]; };
